export const selectedCountry = {
  placeholder: "Selecciona un país",
};
